import { Row, Col, Container, Spinner } from "react-bootstrap";
import classes from "../../../pages/IntegrationWizard.module.scss"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Skeleton } from "@mui/material";

const IntegrationInvoiceSpinner = () =>{
    return(
        <Row className = "g-5">
            <Col className="col-md-5">
                <div className={classes["titleRows"]}>
                    {/* <span><h3><ReceiptIcon/>Enter invoice data</h3></span>
                    <div className={classes["wizard-text"]}>Here, you can enter your invoice information. The information you write will be reflected on the right in the preview object. Note! The amount of information your invoice requires is controlled by the "Complexity" parameter. We'll learn how to pass more information about your invoices when we talk about "Complexity".
                    </div> */}
                    <span><h3><DataObjectIcon/>Payload Object preview</h3></span>
                    <div className={classes["wizard-text"]}>This is Object preview. At this moment, we're only learning about the basic information needed for an invoice, so we're only building the Object keyword.
                        As we move on, we will add other information (Steps and ReturnDoc)
                    </div>
                </div>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <Skeleton width="100%"/>
                </div>
                <div className={classes["form-wrapper"]}>
                    <form>
                    <Skeleton style={{WebkitTransform:"none"}} width="100%" height="55vh"/>
                    </form>
                </div>
                
            </Col>
            <Col className="my-auto p-0 m-0">
                    <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
            </Col>
            <Col className="col-md-6 order-md-last">
                <div className={classes["titleRows"]}>
                    {/* <span><h3><DataObjectIcon/>Object preview</h3></span>
                    <div className={classes["wizard-text"]}>This is Object preview. At this moment, we're only learning about the basic information needed for an invoice, so we're only building the Object keyword.
                        As we move on, we will add other information (Steps and ReturnDoc).<br/><br/><br/>
                        
                    </div> */}
                    <span><h3><DataObjectIcon/>Field descriptions</h3></span>
                    <div className={classes["wizard-text"]}>
                        Below you can find more about the fields required in the invoice
                    </div>
                </div>
                <div className={classes["form-wrapper"]} style={{textAlign : "left"}}>
                <Skeleton style={{WebkitTransform:"none"}} height="60vh"/>
                </div>
            </Col>
        </Row>
    )
}

export default IntegrationInvoiceSpinner;